import { render, staticRenderFns } from "./CategoryProfile.vue?vue&type=template&id=35ed79ca"
import script from "./CategoryProfile.vue?vue&type=script&lang=js"
export * from "./CategoryProfile.vue?vue&type=script&lang=js"
import style0 from "./CategoryProfile.vue?vue&type=style&index=0&id=35ed79ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports